import React, { useEffect, useState } from "react";
import { getAllActive } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";

function CampaignOperatorGameUpdatePage(props) {
    const [campaign, setCampaign] = useState(null);
    const [operatorGameConfig, setOperatorGameConfig] = useState(null);
    const [inputs, setInputs] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getAllActive("operator-game-config/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available OperatorGameConfigs");
            } else {
                setOperatorGameConfig(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("campaign/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available campaigns");
            } else {
                setCampaign(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });
    }, []);

    useEffect(() => {
        if (campaign && operatorGameConfig) {
            setInputs([
                {
                    inputType: inputType.SELECT,
                    labelText: "Campaign",
                    required: true,
                    inputId: "campaign_id",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(campaign, "name")
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "OperatorGameConfig",
                    required: true,
                    inputId: "operator_game_config_id",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(operatorGameConfig, "internal_game_id")
                }
            ])
        }
    }, [operatorGameConfig, campaign])

    return (
        <GenericInsertUpdatePage inputs={inputs}
            setLoggedIn={props.setLoggedIn}
            endpoint={"campaign-operator-gameconfig/update"}
            pageTitle={"Update Campaign Game Config"}
            isUpdate={true}
            getEndpoint={"campaign-operator-gameconfig/read"}
            entityName={"Campaign Game Config"} />
    )
}

export default CampaignOperatorGameUpdatePage;